import type { TaskExecution } from "../features/task";
import type { Process } from "../model/Process";
import type { ProcessExecution } from "../model/ProcessExecution";
import { unauthenticatedAPI as API, responseOf } from "./base";

export const getTasksByPublicExecutorId = (
  publicExecutorId: string,
  organizationId: string,
): Promise<Process> =>
  responseOf(
    API.get(`/executors/public/${publicExecutorId}/tasks`, {
      params: { organizationId },
    }),
  );

export const execute = (
  publicExecutorId: string,
  taskSubmission: TaskExecution[],
  organizationId: string,
  subjectId?: string,
  executionId?: string,
): Promise<ProcessExecution> =>
  responseOf(
    API.post(`/executors/public/${publicExecutorId}/execute`, taskSubmission, {
      params: { subjectId, executionId, organizationId },
    }),
  );

export const getProcessExecutionByPublicExecutorIdAndProcessExecutionId = (
  publicExecutorId: string,
  organizationId: string,
  processExecutionId: string,
): Promise<ProcessExecution> =>
  responseOf(
    API.get(
      `/executors/public/${publicExecutorId}/executions/${processExecutionId}`,
      {
        params: { organizationId },
      },
    ),
  );

export const getProcessExecutionTasksByPublicExecutorIdAndProcessExecutionId = (
  publicExecutorId: string,
  organizationId: string,
  processExecutionId: string,
): Promise<TaskExecution[]> =>
  responseOf(
    API.get(
      `/executors/public/${publicExecutorId}/executions/${processExecutionId}/tasks`,
      {
        params: { organizationId },
      },
    ),
  );
